var _ = require('underscore');
module.exports = function(options){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
__p+='';

  let {
    property
  } = options;

__p+='\n\n<div class="mini-card-item clearfix" data-ldpurl="'+
((__t=( property.ldpUrl ))==null?'':__t)+
'" data-agentid="'+
((__t=( property.agent_id ))==null?'':__t)+
'"  data-listingid="'+
((__t=( property.listing_id ))==null?'':__t)+
'" data-omtag="'+
((__t=( property.omTag))==null?'':__t)+
'" data-status="'+
((__t=( property.dataStatus))==null?'':__t)+
'">\n    <div class="mini-card-photo-wrap">\n        <div class="mini-card-photo '+
((__t=( MOVE.MapMiniCard.setMapPinStrechedImageClass(property.photo) ))==null?'':__t)+
'" data-label="mini-card-photo" >\n            ';
 if(property.photo){ 
__p+='\n            <img src="'+
((__t=( MOVE.MapMiniCard.getMiniCardPhoto(property.photo) ))==null?'':__t)+
'" alt="'+
((__t=( property.address ))==null?'':__t)+
'" title="'+
((__t=( property.address ))==null?'':__t)+
'">\n            ';
 } else{ 
__p+='\n            <div class="coming-soon-img '+
((__t=( MOVE.MapMiniCard.getComingSoonPhoto()))==null?'':__t)+
'"></div>\n            ';
 } 
__p+='\n            <!--Open house/ New labels large devices SRP Map-->\n            <div class="mini-card-photo-label">\n                <div class="srp-item-photo-label">\n                    ';
 if(property.search_flags.is_new_listing) { 
__p+='\n                    <span class="label label-green" data-label="property-label-new">New</span>\n                    ';
 } 
__p+='\n                    ';
 if(property.search_flags.is_pending) { 
__p+='\n                    <span class="label label-red" data-label="property-label-pending">Pending</span>\n                    ';
 } 
__p+='\n                    ';
 if(property.search_flags.is_contingent) { 
__p+='\n                    <span class="label label-red" data-label="property-label-contingent">Contingent</span>\n                    ';
 } 
__p+='\n                    ';
 if(property.open_house_display) { 
__p+='\n                    <span class="label label-dark-transparent label-outline-none"> Open <span\n                                class="srp-item-house-label">House</span> '+
((__t=( property.open_house_display ))==null?'':__t)+
'</span>\n                    ';
 } 
__p+='\n                </div>\n            </div>\n        </div>\n    </div>\n    <div class="mini-card-body">\n        <ul class="list-unstyled">\n            ';
 if (property.dataStreetHome) {
              var status_text;
              if (property.status === "for_sale"){
                status_text = "For sale";
              }
              else if (property.status === "recently_sold") {
                status_text = "Sold";
              }
              else if (property.status === "off_market") {
                status_text = "Off market";
              }
              
__p+='\n            <li class="mini-card-label ellipsis '+
((__t=( property.status ))==null?'':__t)+
'" data-label="mini-card-address"><label class="label">'+
((__t=( status_text ))==null?'':__t)+
'</label></li>\n            ';
 } 
__p+='\n            <li>\n                <ul class="list-unstyled price-display">\n                    ';
 if (property.priceDisplay === "") { 
__p+='\n                    <li class="font-semibold" data-label="mini-card-price">No Estimate Available</li>\n                    ';
 } else{ 
__p+='\n                    <li class="mini-card-price ellipsis" data-label="mini-card-price">'+
((__t=( property.priceDisplay ))==null?'':__t)+
'</li>\n                    ';
/* Price for large devices SRP Map  DOM STRUCTURE REQUIERES CHANGES IN CSS FILE SRP-MINICARDS-DESKTOP.SCSS */
__p+='\n                    <li class="mini-card-price-lg ellipsis '+
((__t=( MOVE.MapMiniCard.getMiniCardPriceClass(property.status)))==null?'':__t)+
'" data-label="mini-card-price">'+
((__t=( property.priceDisplay ))==null?'':__t)+
'<span class="mini-card-price-helper '+
((__t=( MOVE.MapMiniCard.getMiniCardPriceTagClass(property.status)))==null?'':__t)+
'">/month</span></li>\n                    ';
 } 
__p+='\n                </ul>\n            </li>\n             <li>\n                <ul class="property-meta list-horizontal">\n                    ';
 if(property.propertyType === "land"){ 
__p+='\n                    <li data-label="property-meta-land">Land</li>\n                    ';
 } else{ 
__p+='\n                    ';
 if(property.bed_display || property.bed){ 
__p+='\n                    <li data-label="property-meta-beds" class="data-value">'+
((__t=( property.bed_display || property.bed ))==null?'':__t)+
' bd</li>\n                    ';
 } 
__p+='\n                    ';
 if(property.bath_display || property.bath){ 
__p+='\n                    <li data-label="property-meta-baths" class="data-value">'+
((__t=( property.bath_display || property.bath ))==null?'':__t)+
' ba</li>\n                    ';
 } 
__p+='\n                    ';
 } 
__p+='\n                    <!--Meta sqft for large devices SRP Map-->\n                    ';
 if(property.sqft_display && property.sqft_display != 0 && property.sqft_display != "0"
                          && property.sqft_display != "0 - 0"){ 
__p+='\n                    <li data-label="property-meta-sqft" class="property-meta-lg data-value">'+
((__t=( property.sqft_display ))==null?'':__t)+
' sq ft</li>\n                    ';
 } 
__p+='\n                </ul>\n            </li>\n            <li class="mini-card-address ellipsis" data-label="mini-card-address">'+
((__t=( property.address ))==null?'':__t)+
'</li>\n            <!--Complete address for large devices SRP Map-->\n            <li class="mini-card-address-lg ellipsis" data-label="mini-card-address">\n                ';
 if(property.community_name) { 
__p+='\n                <span class="mini-card-community">'+
((__t=( property.community_name ))==null?'':__t)+
' &#47; </span>\n                ';
 } 
__p+='\n                ';
 if(property.address && property.address !== property.community_name) { 
__p+=''+
((__t=( property.address ))==null?'':__t)+
',';
 } 
__p+=' '+
((__t=( property.city ))==null?'':__t)+
', '+
((__t=( property.state ))==null?'':__t)+
', '+
((__t=( property.zip ))==null?'':__t)+
'\n                <li class="mini-card-address recent-sold-around-price ellipsis" data-label="mini-card-address">'+
((__t=( property.address ))==null?'':__t)+
'</li>\n            </li>\n        </ul>\n    </div>\n    <!--Link to LDP large devices SRP Map-->\n    <a href="'+
((__t=( property.ldpUrl ))==null?'':__t)+
'" class="mini-card-anchor-overlay"></a>\n</div>\n';
return __p;
};



// WEBPACK FOOTER //
// ./templates/map_card_small.jst.ejs